export enum EDmsAction {
  download = 1,
  upload,
  delete,
  sync
}